import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';
import cx from 'classnames';

export interface Props {
  className?: string;
  icon?: React.ReactNode;
  hovered?: React.ReactNode | string;
  label?: string;
  note?: string;
  onClick?: (item?: any) => void;
}

export interface State {
  isHovered?: boolean;
}

class ListItem extends React.Component<Props, State> {
  state: State = {
    isHovered: false,
  };
  onHover = isHovered => {
    this.setState({
      isHovered,
    });
  };
  render() {
    const { className, icon, label, note, onClick, hovered } = this.props;
    const { isHovered } = this.state;
    return (
      <div
        className={className}
        onClick={onClick}
        onMouseEnter={this.onHover.bind(this, true)}
        onMouseLeave={this.onHover.bind(this, false)}
      >
        {icon && <div className="item-icon">{icon}</div>}
        <div className="item-info">
          <div className="item-label">{label}</div>
          {note && <div className="item-note">{note}</div>}
        </div>
        {hovered && (
          <div className={cx('item-hovered', isHovered && 'hovered')}>
            {hovered}
          </div>
        )}
      </div>
    );
  }
}

export default styled(ListItem)`
  display: flex;
  width: 100%;
  align-items: center;
  flex-flow: row;
  height: 3.75rem;
  min-height: 3.75rem;
  max-height: 3.75rem;
  padding: 0.5rem;
  transition: all 0.1s ease;
  > div {
    margin: 0rem 0.25rem;
  }
  cursor: pointer;
  &:hover {
    background-color: ${colors.grey50};
    transition: all 0.1s ease;
  }
  .item-icon {
    display: flex;
  }
  .item-info {
    display: flex;
    flex-flow: column;
    margin-left: 0.5rem;
    .item-label {
      font-size: 0.9125rem;
    }
    .item-note {
      font-size: 0.8125rem;
      color: ${colors.grey900};
    }
  }
  .item-hovered {
    justify-content: flex-end;
    flex-grow: 1;
    display: flex;
    margin-right: 1rem;
    flex-flow: row;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.1s, opacity 0.2s ease;
  }
  .item-hovered.hovered {
    visibility: visible;
    opacity: 1;
    transition: visibility 0.1s, opacity 0.1s ease;
  }
`;
